import type { SelectItem } from '@/components/Atoms/FaceliftSelect/FaceliftSelect.types';

export const portItems: SelectItem[] = [
	{ value: 'GraftLogs', label: 'GraftLogs' },
	{ value: 'Mindsight', label: 'Mindsight' },
	{ value: 'PaymentsMSL', label: 'Payments MSL' },
	{ value: 'SalesRep', label: 'SalesRep' },
	{ value: 'Woundcare+', label: 'Woundcare+' },
];

export const environmentsItems: SelectItem[] = [
	{ value: 'PROD', label: 'PROD' },
	{ value: 'PREPROD', label: 'PREPROD' },
	{ value: 'STAGE', label: 'STAGE' },
	{ value: 'QA', label: 'QA' },
];

export const userTypeItems: SelectItem[] = [
	{ value: 'internal', label: 'Internal' },
	{ value: 'external', label: 'External' },
];

export const dateRanges = [
	{ label: 'Today', value: 'today' },
	{ label: 'Yesterday', value: 'yesterday' },
	{ label: 'This Week', value: 'this_week' },
	{ label: 'Last Week', value: 'last_week' },
	{ label: 'This Month', value: 'this_month' },
	{ label: 'Last Month', value: 'last_month' },
	{ label: 'This Year', value: 'this_year' },
	{ label: 'Last Year', value: 'last_year' },
	{ label: 'Year to Date', value: 'year_to_date' },
];

export const createdOnDateRanges = [
	{ label: 'On', value: 'on' },
	{ label: 'Today', value: 'today' },
	{ label: 'This Week', value: 'this_week' },
	{ label: 'Last Week', value: 'last_week' },
	{ label: 'This Month', value: 'this_month' },
	{ label: 'Last Month', value: 'last_month' },
	{ label: 'This Year', value: 'this_year' },
	{ label: 'Last Year', value: 'last_year' },
	{ label: 'Year to Date', value: 'year_to_date' },
	{ label: 'Yesterday', value: 'yesterday' },
];

export const woundTypeMap = [
	{
		label: 'DFU',
		value: 953870000,
	},
	{
		label: 'VLU',
		value: 953870001,
	},
	{
		label: 'Pressure Ulcer',
		value: 953870002,
	},
	{
		label: 'Mohs',
		value: 953870003,
	},
	{
		label: 'Other',
		value: 953870004,
	},
];

export const bvServiceLocation = [
	{
		label: 'POS11:Physician Office',
		value: 953870000,
	},
	{
		label: 'POS12:Home',
		value: 953870001,
	},
	{
		label: 'POS13:Assisted Living Facility',
		value: 953870002,
	},
	{
		label: 'POS22:On Campus Outpatient Hospital',
		value: 953870005,
	},
	{
		label: 'POS32:Nursing Facility',
		value: 953870003,
	},
	{
		label: 'NA:None Selected',
		value: 953870004,
	},
];

export const portRoleBasedPermissions: { [role: string]: string[] } = {
	SalesRep: [
		'Activity: Create',
		'Activity: Edit',
		'Activity: Visualize',
		// 'Clinics:View',
		'BenefitVerification:Visualize',
		'ConfirmedGrafts:Visualize',
		// 'ConsignmentManagment:Create',
		// 'ConsignmentManagment:Visualize',
		// 'Customers: Visualize',
		// 'CustomersBV: Visualize',
		// 'CustomersContacts: Visualize',
		// 'CustomersOrders: Visualize',
		'Dashboard:Visualize',
		// 'DashboardDefault:Visualize',
		'DenialSupport:Visualize',
		'Documents:Visualize',
		'GraftsToAssign:Visualize',
		'Invoices:Visualize',
		// 'InvoicesView:Visualize',
		'OrderConsignmentManagment:Create',
		'OrderConsignmentManagment:Visualize',
		// 'Orders:Visualize',
		// 'RepWeeklyReport:Visualize',
		'ReturnsConsignment:Visualize',
		'Returns:Visualize',
		'SalesPipeline: AgreementRequest',
		'SalesPipeline: Visualize',
		'SalesPipelineConflictApproved: Visualize',
		'SalesPipelineLeads: Create',
		'SalesPipelineLeads: Edit',
		'SalesPipelineLeads: Qualify',
		'SalesPipelineLeads: Visualize',
		'SalesPipelineOpportunity: Edit',
		'SalesPipelineOpportunity: Visualize',
		// 'Support:Create',
		// 'Support:Edit',
		// 'Support:Visualize',
		'SupportTickets:Create',
		'SupportTickets:Edit',
		'SupportTickets:Visualize',
		// 'TissueTransfer:Edit',
		// 'TissueTransfer:Visualize',
		// 'TrunkStock:Visualize',
		'UsersRoles:Profile',
		// 'SalesRepPayments:Visualize',
		'SmartInsurance:Visualize',
	],
	'Woundcare+Manager': [
		'Accounting:Visualize',
		'BenefitVerification:Create',
		'BenefitVerification:Edit',
		'BenefitVerification:Visualize',
		'BillingTools:Visualize',
		// 'Clinics:View',
		'Collections:Visualize',
		'ConfirmedGrafts:Edit',
		'ConfirmedGrafts:Visualize',
		'Dashboard:Visualize',
		// 'DashboardDefault:Visualize',
		'DenialSupport:Create',
		'DenialSupport:Visualize',
		'Documents:Create',
		'Documents:Visualize',
		'GraftsToAssign:Create',
		'GraftsToAssign:Edit',
		'GraftsToAssign:Visualize',
		'Invoice:Pay',
		'InvoicesView:Visualize',
		'Orders:Create',
		'Orders:Edit',
		'Orders:Visualize',
		'Patients:Create',
		'Patients:Edit',
		'Patients:Visualize',
		'Returns:Create',
		'Returns:Visualize',
		// 'ShippedOrders:Create',
		// 'ShippedOrders:Edit',
		// 'ShippedOrders:Visualize',
		// 'Support:Create',
		// 'Support:Edit',
		// 'Support:Visualize',
		'SupportTickets:Create',
		'SupportTickets:Edit',
		'SupportTickets:Visualize',
		'UsersRoles:Profile',
		// 'OpenInvoices:Visualize',
		// 'PaidInvocies:Visualize',
		'SmartInsurance:Visualize',
		'Draft:Create',
		'Draft:Visualize',
	],
	'Woundcare+Contributor': [
		'BenefitVerification:Create',
		'BenefitVerification:Edit',
		'BenefitVerification:Visualize',
		// 'Clinics:View',
		'ConfirmedGrafts:Edit',
		'ConfirmedGrafts:Visualize',
		'Dashboard:Visualize',
		// 'DashboardDefault:Visualize',
		'DenialSupport:Create',
		'DenialSupport:Visualize',
		'Documents:Create',
		'Documents:Visualize',
		'GraftsToAssign:Create',
		'GraftsToAssign:Edit',
		'GraftsToAssign:Visualize',
		'Orders:Create',
		'Orders:Edit',
		'Orders:Visualize',
		'Patients:Create',
		'Patients:Edit',
		'Patients:Visualize',
		'Returns:Create',
		// 'Returns:Edit',
		'Returns:Visualize',
		// 'ShippedOrders:Create',
		// 'ShippedOrders:Edit',
		// 'ShippedOrders:Visualize',
		// 'Support:Create',
		// 'Support:Edit',
		// 'Support:Visualize',
		'SupportTickets:Create',
		'SupportTickets:Edit',
		'SupportTickets:Visualize',
		'UsersRoles:Profile',
		'SmartInsurance:Visualize',
		'Draft:Create',
		'Draft:Visualize',
	],
	'Woundcare+Accounting': [
		'Accounting:Visualize',
		'BenefitVerification:Visualize',
		'BillingTools:Visualize',
		// 'Clinics:View',
		'Collections:Visualize',
		'ConfirmedGrafts:Visualize',
		'Dashboard:Visualize',
		// 'DashboardDefault:Visualize',
		'DenialSupport:Create',
		'DenialSupport:Visualize',
		'Documents:Create',
		'Documents:Visualize',
		'GraftsToAssign:Visualize',
		'Invoice:Pay',
		'InvoicesView:Visualize',
		'Orders:Visualize',
		'Patients:Visualize',
		'Returns:Create',
		'Returns:Visualize',
		// 'ShippedOrders:Visualize',
		// 'Support:Create',
		// 'Support:Edit',
		// 'Support:Visualize',
		'SupportTickets:Create',
		'SupportTickets:Edit',
		'SupportTickets:Visualize',
		'UsersRoles:Profile',
		// 'OpenInvoices:Visualize',
		// 'PaidInvocies:Visualize',
		'SmartInsurance:Visualize',
	],
	Mindsight: [
		'AssignTissue:Visualize',
		'BenefitVerification:Create',
		'BenefitVerification:Edit',
		'BenefitVerification:Visualize',
		// 'Clinics:View',
		'ConfirmedGrafts:Edit',
		'ConfirmedGrafts:Visualize',
		'Dashboard:Visualize',
		'DenialSupport:Create',
		'DenialSupport:Visualize',
		'Documents:Create',
		'Documents:Visualize',
		'GraftsToAssign:Create',
		'GraftsToAssign:Edit',
		'GraftsToAssign:Visualize',
		'Invoice:Pay',
		'Invoices:Visualize',
		'Orders:Create',
		'Orders:Edit',
		'Orders:Visualize',
		'Patients:Create',
		'Patients:Edit',
		'Patients:Visualize',
		'Returns:Create',
		'Returns:Visualize',
		// 'ShippedOrders:Create',
		// 'ShippedOrders:Edit',
		// 'ShippedOrders:Visualize',
		// 'Support:Create',
		// 'Support:Edit',
		// 'Support:Visualize',
		'SupportTickets:Create',
		'SupportTickets:Edit',
		'SupportTickets:Visualize',
		'UsersRoles:Profile',
		'SmartInsurance:Visualize',
		'Draft:Create',
		'Draft:Visualize',
	],
	MindsightContributor: [
		'AssignTissue:Visualize',
		'BenefitVerification:Create',
		'BenefitVerification:Edit',
		'BenefitVerification:Visualize',
		// 'Clinics:View',
		'ConfirmedGrafts:Edit',
		'ConfirmedGrafts:Visualize',
		'Dashboard:Visualize',
		'DenialSupport:Create',
		'DenialSupport:Visualize',
		'Documents:Create',
		'Documents:Visualize',
		'GraftsToAssign:Create',
		'GraftsToAssign:Edit',
		'GraftsToAssign:Visualize',
		'Invoices:Visualize',
		'Orders:Create',
		'Orders:Edit',
		'Orders:Visualize',
		'Patients:Create',
		'Patients:Edit',
		'Patients:Visualize',
		'Returns:Create',
		'Returns:Visualize',
		// 'ShippedOrders:Create',
		// 'ShippedOrders:Edit',
		// 'ShippedOrders:Visualize',
		// 'Support:Create',
		// 'Support:Edit',
		// 'Support:Visualize',
		'SupportTickets:Create',
		'SupportTickets:Edit',
		'SupportTickets:Visualize',
		'UsersRoles:Profile',
		'SmartInsurance:Visualize',
		'Draft:Create',
		'Draft:Visualize',
	],
	GraftLogs: [
		'GraftsToAssign:Create',
		'GraftsToAssign:Visualize',
		'GraftsToAssign:Edit',
		'ConfirmedGrafts:Create',
		'ConfirmedGrafts:Visualize',
		'ConfirmedGrafts:Edit',
		// 'Support:Create',
		// 'Support:Visualize',
		// 'Support:Edit',
		'SupportTickets:Create',
		'SupportTickets:Visualize',
		'SupportTickets:Edit',
		// 'Support:Delete',
		'UsersRoles:Profile',
		'Patients:Visualize',
		// 'Clinics:View',
		'SmartInsurance:Visualize',
	],
	PaymentsMSL: [
		'Invoices:Visualize',
		'UsersRoles:Profile',
		// 'Clinics:View',
		'Invoice:Pay',
		'SupportTickets:Create',
		'SupportTickets:Edit',
		'SupportTickets:Visualize',
	],
	'PaymentsWC+': [
		'Invoices:Visualize',
		'UsersRoles:Profile',
		// 'InvoicesView:Visualize',
		// 'Clinics:View',
		// 'DenialSupport:Create',
		// 'DenialSupport:Visualize',
		// 'DenialSupport:Edit',
		'Invoice:Pay',
		'SupportTickets:Create',
		'SupportTickets:Edit',
		'SupportTickets:Visualize',
	],
	// PaymentMSLAdmin: [
	// 	'DenialSupport:Create',
	// 	'DenialSupport:Visualize',
	// 	'DenialSupport:Edit',
	// ],
	'Admin-GraftLogs': [
		// 'ProductsByApp:Visualize',
		'UsersRoles:Visualize',
		'APPCrashLogs:Visualize',
		'UsersRoles:Create',
		'UsersRoles:Edit',
		'Audit:Visualize',
		// 'PaymentLock: Visualize',
		'APPCrashLogs:Visualize',
		'TechnicalAlerts:Visualize',
	],
	'Admin-Woundcare+': [
		// 'ProductsByApp:Visualize',
		'UsersRoles:Visualize',
		'APPCrashLogs:Visualize',
		'UsersRoles:Create',
		'UsersRoles:Edit',
		'Audit:Visualize',
		'PaymentLock: Visualize',
		// 'AllInvoices:Visualize',
		// 'OpenInvoices:Visualize',
		// 'PaidInvocies:Visualize',
		'TechnicalAlerts:Visualize',
	],
	'Admin-SalesRep': [
		// 'ProductsByApp:Visualize',
		'UsersRoles:Visualize',
		'UsersRoles:Create',
		'UsersRoles:Edit',
		'Audit:Visualize',
		// 'PaymentLock: Visualize',
		'APPCrashLogs:Visualize',
		// 'AllInvoices:Visualize',
		// 'OpenInvoices:Visualize',
		// 'PaidInvocies:Visualize',
		// 'MSLInvoices:View',
		'TechnicalAlerts:Visualize',
	],
	'Admin-MindSight-PaymentMSL-PaymentsWC+': [
		// 'ProductsByApp:Visualize',
		'UsersRoles:Visualize',
		'UsersRoles:Create',
		'UsersRoles:Edit',
		'Audit:Visualize',
		'PaymentLock: Visualize',
		'APPCrashLogs:Visualize',
		// 'AllInvoices:Visualize',
		// 'OpenInvoices:Visualize',
		// 'PaidInvocies:Visualize',
		// 'MSLInvoices:View',
		'TechnicalAlerts:Visualize',
	],
};

export const permissionToUrl = {
		'Dashboard:Visualize': '/',
		'BenefitVerification:Visualize': '/benefits-verifications',
		'Orders:Visualize': '/requests',
		'OrderConsignmentManagment:Visualize': '/consignments/orders',
		'Returns:Visualize': '/returns',
		'ReturnsConsignment:Visualize': '/returns',
		'Invoices:Visualize': '/all-invoices',
		'MSLInvoices:View': '/all-invoices',
		'InvoicesView:Visualize': '/open-invoices',
		'Collections:Visualize': '/collections',
		'DenialSupport:Visualize': '/denial-support',
		'BillingTools:Visualize': '/billing-tools',
		'GraftsToAssign:Visualize': '/grafts-assign',
		'ConfirmedGrafts:Visualize': '/grafts-confirmed',
		'Patients:Visualize': '/manage-patients',
		'PaymentLock: Visualize': '/payment-locks',
		'Documents:Visualize': '/documents',
		'SupportTickets:Visualize': '/support',
		'UsersRoles:Visualize': '/manage-users',
		'UsersRoles:Profile': '/profile',
		'Audit:Visualize': '/audit',
		'APPCrashLogs:Visualize': '/app-crash-logs',
		'Draft:Visualize': '/drafts',
		// 'RepWeeklyReport:Visualize': '/salesReport'
};

// Re-export order constants
export { shippingMethodItems, statusOptions } from './orderConstants';


export const portBasedApplication = {
	SalesRep: 'SalesRep',
	'Woundcare+': 'Woundcare+',
	Mindsight: 'Mindsight',
	GraftLogs: 'GraftLogs',
	PaymentsMSL: 'Payments MSL',
};

export const environments = {
	'develop': 'QA',
	'stage': 'STAGE',
	'prod': 'PROD',
	'preprod': 'PREPROD',
}

// Form Types for Draft System
export const FORM_TYPES = {
	ORDER_REQUEST_PATIENT: 'ORDER_REQUEST_PATIENT',
	ORDER_REQUEST_CLINIC: 'ORDER_REQUEST_CLINIC',
	RETURN_ORDER: 'RETURN_ORDER',
	CONSIGNMENT_ORDER: 'CONSIGNMENT_ORDER',
	BENEFIT_VERIFICATION: 'BENEFIT_VERIFICATION',
	PATIENT: 'PATIENT',
	SUPPORT_TICKET: 'SUPPORT_TICKET',
	// Future forms will be added here
} as const;

export const DRAFT_TYPE_LABELS = {
	ORDER_REQUEST_PATIENT: 'Patient Order Form',
	ORDER_REQUEST_CLINIC: 'Clinic Order Form',
	RETURN_ORDER: 'Return Order Form',
	CONSIGNMENT_ORDER: 'Consignment Order Form',
	BENEFIT_VERIFICATION: 'Benefit Verification Form',
	PATIENT: 'Patient Form',
	SUPPORT_TICKET: 'Support Ticket Form',
	// Future labels will be added here
} as const;
